import React, { Fragment } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import SvgCopyIcon from '../../Component/svg-copy-icon';


const copied = () => {
    toast("Copied!", {
        toastId: 100, progressStyle: {
            background: '#4243F1', // Change this to the desired color
        }, icon: SvgCopyIcon,
        position: toast.POSITION.BOTTOM_RIGHT, className: 'toast-message'
    });
}

const ShareURLDialogContent = ({ link,urlType }) => (
    <>
        <div className="container-fluid d-flex justify-content-center align-items-center bg-light">
                            <div className="card shadow border-0 rounded-lg">
                                <div className="card-body p-4">
                                    {/* Step 1 */}
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 1: Copy Link</p>
                                        <div className="d-flex">
                                            {/* <div className="input-group">
                                                 <CopyToClipboard
                                                    onCopy={copied}
                                                    text={link}>
                                                    <a className="form-control pt-3" style={{color : "#0a58ca", textDecoration : "underline"}} readOnly>{urlType === "AGENT" ? "AI Lending Agent Link" : "SDK Link"}</a>
                                               </CopyToClipboard> 

                                               
                                                
                                            </div> */}

                                            <CopyToClipboard
                                                onCopy={copied}
                                                text={link}>
                                                <div className="upload-statement-btn align-items-center justify-content-center cursor-pointer" style={{fontSize: "16px", width: '100%',textAlign:'center'}}>Copy URL</div>
                                               </CopyToClipboard> 
                                        </div>
                                    </div>
                                     <hr className="mt-2" />
                                    {urlType === "AGENT" &&
                                    <Fragment>
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 2: <b>Share The Link</b></p>
                                        <p className="text-secondary">Send the AI lending Agent URL to the user via sms, whatsapp or email.</p>
                                    </div>
                                    <hr className="mt-2" />
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 3: <b>User Completes Journey</b> </p>
                                        <p className="text-secondary">User opens the link and submits required documents.</p>
                                    </div>
                                    <hr className="mt-2" />
                                    
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 4: <b>Receive Documents</b></p>
                                        <p className="text-secondary">Get all submitted docs for lender review.</p>
                                    </div></Fragment>}

                                    {urlType === "SDK" &&
                                    <Fragment>
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 2: <b>Share The Link</b></p>
                                        <p className="text-secondary">Send the SDK URL to the user via sms, whatsapp or email.</p>
                                    </div>
                                    <hr className="mt-2" />
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 3: <b>User Completes Journey</b> </p>
                                        <p className="text-secondary">User opens the link and provides consent to share bureau and bank data.</p>
                                    </div>
                                    <hr className="mt-2" />
                                    
                                    <div className="mb-4">
                                        <p className="text-muted mb-2 font-weight-bold">Step 4: <b>Receive Bureau and Bank Data</b></p>
                                        <p className="text-secondary">Get Credit Score and Bank Transactions Analysis</p>
                                    </div></Fragment>}
                                </div>
                            </div>
                        </div>

                    {/* <div className="info-details-box row p-0 m-0 px-2 py-2"
                        style={{
                            overflowX: 'scroll',
                            overflowY: 'scroll'
                        }}>
                        <p className='p-0 m-0 ps-1' style={{ fontWeight: 'light', color: "#727272" }}>{link}</p>
                    </div>
                    <div className=" px-1 mt-4 mb-2">
                        <CopyToClipboard
                            onCopy={copied}
                            text={link}>
                            <div className="upload-statement-btn text-center cursor-pointer">Copy URL</div>
                        </CopyToClipboard>
                    </div> */}
    </>
);

export default ShareURLDialogContent;
